import React from "react";
import Typography from "@mui/material/Typography";
import { Avatar, Badge, Box, Card, Divider } from "@mui/material";
import moment from "moment";

const MessageCard = ({ message, user }) => {
  const stringToHash = (str) => {
    let hash = 0;
    for (let i = 0; i < str.length; i++) {
      hash = str.charCodeAt(i) + ((hash << 5) - hash);
    }
    return hash;
  };

  const nameToColor = (name) => {
    var hash = stringToHash(name);
    const color = `#${((hash & 0x00ffffff) | 0x1000000).toString(16).slice(1)}`;
    return color;
  };

  const getTimeDiff = (timestamp) => {
    var diff = moment().diff(moment(timestamp), "minutes");
    return diff < 60 ? `${diff} min ago` : "older than 1h";
  };

  return (
    <Card
      sx={{
        p: 1,
        maxWidth: "800px",
        width: "fit-content",
        minWidth: "200px",
      }}
    >
      {message && user && (
        <Box
          sx={{ display: "flex", flexDirection: "row", alignItems: "center", textAlign: "center", alignmentBaseline: "baseline" }}
        >
          <Box>
            <Box sx={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
              <Badge
                color="success"
                badgeContent="online"
                variant="dot"
                overlap="circular"
                invisible={!user.isOnline}
                anchorOrigin={{
                  vertical: "top",
                  horizontal: "left",
                }}
              >
                <Avatar
                  sx={{ width: 32, height: 32 }}
                  alt={user.nickname}
                  src={`/static/images/${user.avatarFileName ?? "default.jpg"}`}
                />
              </Badge>
              <Typography
                variant="caption"
                sx={{
                  fontSize: 16,
                  mr: 1,
                  ml: 1,
                  color: nameToColor(user.nickname),
                }}
              >
                {user.nickname}:
              </Typography>
            </Box>

            <Typography sx={{ fontSize: 12 }}>
              {getTimeDiff(message.timeStamp)}
            </Typography>
          </Box>
          <Divider orientation="vertical" flexItem />

          <Typography
            variant="body1"
            sx={{ fontSize: 16, p: 1, textAlign: "left" }}
          >
            {message.message}
          </Typography>
        </Box>
      )}
    </Card>
  );
};

export default MessageCard;
